module.exports = __webpack_public_path__ + "static/solutions-agency-0175ff1729f08be77f156c1420539ccb.svg";